import { Fragment, useState } from "react";
import { Platform, Pressable, StyleSheet, View, } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
import { Icon } from "./Icon";
import { ThemedText } from "./ThemedText";
const ICON_SIZE = 24;
const LABEL_GAP = 8;
const OPTION_GAP = 16;
const OPTION_MIN_HEIGHT = 24;
export function RadioGroup({ options, value, onChange, label, error, disabled = false, testID, style, labelStyle, optionLabelStyle, }) {
    const { colors } = useCustomTheme();
    const [hoveredOption, setHoveredOption] = useState(null);
    const [focusedOption, setFocusedOption] = useState(null);
    const select = (option) => {
        if (disabled || option.disabled)
            return;
        onChange(option.value);
    };
    return (<View testID={testID} style={[styles.group, style]} accessibilityRole="radiogroup" accessibilityLabel={label}>
      {label ? (<ThemedText style={[{ color: colors.text }, labelStyle]}>
          {label}
        </ThemedText>) : null}

      {options.map((option) => {
            const optionKey = String(option.value);
            const isDisabled = disabled || option.disabled === true;
            const selected = value === option.value;
            const highlighted = !isDisabled &&
                (hoveredOption === optionKey || focusedOption === optionKey);
            const contentColor = isDisabled ? colors.muted : colors.text;
            const iconColor = isDisabled
                ? colors.muted
                : highlighted
                    ? colors.palette.spinach40
                    : colors.palette.spinach30;
            const keyboardProps = {
                onKeyDown: (event) => {
                    const key = event.nativeEvent?.key;
                    if (key !== " " && key !== "Enter")
                        return;
                    event.preventDefault?.();
                    select(option);
                },
            };
            return (<Fragment key={optionKey}>
            <Pressable testID={testID ? `${testID}-option-${optionKey}` : undefined} accessibilityRole="radio" accessibilityLabel={option.label} accessibilityState={{ checked: selected, disabled: isDisabled }} disabled={isDisabled} onPress={() => select(option)} onHoverIn={() => setHoveredOption(optionKey)} onHoverOut={() => setHoveredOption((current) => current === optionKey ? null : current)} onFocus={() => setFocusedOption(optionKey)} onBlur={() => setFocusedOption((current) => current === optionKey ? null : current)} {...keyboardProps} style={[
                    styles.option,
                    Platform.OS === "web"
                        ? { outlineStyle: "none" }
                        : undefined,
                    Platform.OS === "web" && isDisabled
                        ? { cursor: "not-allowed" }
                        : undefined,
                ]}>
              <Icon iconSet="material-community" icon={selected ? "radiobox-marked" : "radiobox-blank"} size={ICON_SIZE} color={iconColor}/>
              <ThemedText style={[
                    styles.optionLabel,
                    { color: contentColor },
                    optionLabelStyle,
                ]}>
                {option.label}
              </ThemedText>
            </Pressable>
            {selected ? option.content : null}
          </Fragment>);
        })}

      {error ? (<ThemedText testID={testID ? `${testID}-error` : undefined} accessibilityLiveRegion="polite" role="alert" style={[styles.error, { color: colors.danger }]}>
          {error}
        </ThemedText>) : null}
    </View>);
}
const styles = StyleSheet.create({
    group: {
        width: "100%",
        gap: OPTION_GAP,
    },
    option: {
        flexDirection: "row",
        alignItems: "center",
        gap: LABEL_GAP,
        minHeight: OPTION_MIN_HEIGHT,
    },
    optionLabel: {
        flexShrink: 1,
    },
    error: {
        fontSize: 12,
        lineHeight: 14.4,
    },
});
//# sourceMappingURL=RadioGroup.js.map